import React from 'react';

export default function ProgressIndeterminate(props) {
	return (
		<div {...props} className='progress'>
			<div className='indeterminate' />
		</div>
	);
}